import { useState } from "react";

import { useAuthContext } from "hooks/useAuthContext";

import { AccountCircle, History, Publish } from "@mui/icons-material";
import { Card, Divider, Icon, Menu, MenuItem } from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// Data
import data from "../data/reportdata";

const ReportDocumentSection = ({ onClick }) => {
  const { user } = useAuthContext();

  const { columns, rows } = data();

  const handleClick = () => {
    const data = { title: "Report" };
    onClick(data);
  };

  return (
    <Card sx={{ height: "100%" }}>
      {onClick && (
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="space-evenly"
          mx={3}
          my={3}
          px={3}
        >
          {/* <MDButton
          variant="gradient"
          color="info"
          size="medium"
          startIcon={<History />}
          onClick={onClick}
          mr={3}
        >
          View Previous Submissions
        </MDButton> */}
          <MDButton
            variant="gradient"
            color="info"
            size="medium"
            startIcon={<Publish />}
            onClick={handleClick}
          >
            Submit New Progress
          </MDButton>
        </MDBox>
      )}

      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
          // canSearch={true}
        />
      </MDBox>
    </Card>
  );
};

export default ReportDocumentSection;
